import { Box, Typography } from '@mui/material';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import StringHelper from '../../../helpers/string.helper';
import classes from './MixedBarChart.module.scss';
import { ContentTypes } from '../../../enums/ContentTypes';

const TYPE_COLORS = [
  { name: ContentTypes.NEWS, color: '#67BDB7' },
  { name: ContentTypes.OPERATOR, color: '#899FED' },
  { name: ContentTypes.SPORT, color: '#F7C845' },
  { name: ContentTypes.GENERIC, color: '#9DCE7C' },
  { name: ContentTypes.TIP, color: '#42c242' },
];

const MixedBarChart = ({ data }: any) => {
  return (
    <Box className='rounded border p-1' >
      <Typography className={`fs-7 ms-4 my-2 ${classes['label']}`} >
        {data.length > 0 ? `From ${data[0].date} to ${data[data.length - 1].date}` : 'No Data'}
      </Typography>
      <ResponsiveContainer className='chart-box'>
        <BarChart
          data={data}
          margin={{
            top: 10,
            right: 15,
            left: 0,
            bottom: 0,
          }}
        >
          <CartesianGrid strokeDasharray='3 3' />
          <XAxis dataKey='date' />
          <YAxis />
          <Tooltip />
          <Legend verticalAlign='top' height={35}/>
          {TYPE_COLORS.map((type) => <Bar key={StringHelper.generateRandomString(10)} dataKey={type.name} fill={type.color} />)}
        </BarChart>
      </ResponsiveContainer>
    </Box>
  );
}

export default MixedBarChart;
